import {type UISidebarController} from '../../../ui_html/sidebar/UISidebarController.ts'

export class UIDAboutSceneController {
    private readonly sidebarController: UISidebarController
    private readonly aboutSceneContainerDiv: HTMLDivElement

    constructor(sidebarController: UISidebarController) {
        this.sidebarController = sidebarController
        this.aboutSceneContainerDiv = document.getElementById('scene_discord_about_container') as HTMLDivElement
    }

    hide() {
        this.aboutSceneContainerDiv.classList.add('hidden')
    }

    show() {
        this.aboutSceneContainerDiv.classList.remove('hidden')
        this.sidebarController.deactivateAllButtons()
    }
}
